import { memo } from 'react'
import { Box, MenuItem, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { Option, Sentiment } from './SentimentOptions'

export const findSelectedOption = (
  sentimentObj: Sentiment | null | undefined,
  options: Option[],
) => {
  if (!sentimentObj || !('sentiment' in sentimentObj)) return null

  const current = sentimentObj?.sentiment?.toLowerCase()
  return options.find((option: Option) => option.value === current) || null
}

interface MenuItemProps {
  option: Option
  selected: Option | null
  onChange: (option: Option) => void
}

const MenuItemWrapper = memo(
  ({ option, selected, onChange }: MenuItemProps) => {
    const { t } = useTranslation()
    const isSelected = selected?.value === option.value

    return (
      <MenuItem
        onClick={() => onChange(option)}
        tabIndex={0}
        key={option.value}
        selected={isSelected}
      >
        <Box display="flex" alignItems="center">
          <Box marginRight={1}>{option.icon}</Box>
          <Typography sx={{ textTransform: 'capitalize' }}>
            {t(`textAnalysis.sentiment.${option.value}`)}
          </Typography>
        </Box>
      </MenuItem>
    )
  },
)
MenuItemWrapper.displayName = 'MenuItemWrapper'
export { MenuItemWrapper }

export const getScoreText = (
  score: number | undefined,
  type: string | undefined,
): string => {
  if (type === 'auto') {
    return score !== undefined ? ` - ${(score * 100).toFixed(1)}%` : ''
  }
  return ''
}

export const getSentimentButtonStyles = (
  hoverColor: string | undefined,
  color: string | undefined,
  isReadonly: boolean,
) => ({
  color: hoverColor || 'inherit',
  backgroundColor: color || 'transparent',
  border: '1px solid transparent',
  cursor: isReadonly ? 'default' : 'pointer',
  '&:hover': !isReadonly
    ? {
        borderColor: hoverColor || 'transparent',
        backgroundColor: color || 'transparent',
        outline: 'none',
      }
    : {
        backgroundColor: color,
      },
})
